export default function PHP_var_dump() {
  return (
    <div>
      <h1>PHP_var_dump</h1>
    </div>
  );
}
